<template>
  <check-dialog></check-dialog>
  <care-header></care-header>
  <div class="container">
    <div class="main">
      <im-container :im-height="imHeight"></im-container>
    </div>
    <order-container></order-container>
  </div>
</template>

<script>
import CheckDialog from './components/CheckDialog'
import CareHeader from './components/CareHeader'
import ImContainer from './components/ImContainer'
import OrderContainer from './components/OrderContainer'
import configUtil from './assets/js/configUtil'

export default {
  data() {
    return {
      imHeight: 0,
      mailNo: '',
      companyCode: '',
      mtopPrefix: configUtil.getMtopPrefix(), // mtop的前缀
      mtopSubDomain: configUtil.getMtopSubDomain(), // mtop的子域
      mtopMainDomain: configUtil.getMtopMainDomain() // mtop的主域
    }
  },
  ready() {
    // 计算聊天视口高度
    var me = this;
    me.imHeight = window.innerHeight - 70;
    window.onresize = function () {
      me.imHeight = window.innerHeight - 70;
    }
  },
  components: {
    CheckDialog,
    CareHeader,
    ImContainer,
    OrderContainer
  },
  events: {
    'init-IM': function(companyCode, mailNo) {
      // 页面加载时请求物流信息和推荐问题
      var me = this;
      me.companyCode = companyCode;
      me.mailNo = mailNo;

      var promise = lib.mtop.request({
        api: 'mtop.cainiao.delibird.portal.new.getpcdetail',
        v: '1.0',
        data: {"companyCode": companyCode, "mailNo": mailNo,"from":"PC_OFFICIAL"},
        appkey: '4272', // 非必须，默认不需要传
        ecode: 1,
        type: 'GET', // 非必须。请求类型（GET/POST），默认是GET
        dataType: 'jsonp', // 非必须。数据类型（jsonp/originaljsonp/json），默认jsonp
        timeout: 20000 // 非必须。接口超时设置，默认为20000ms
      });

      promise.then(function(resJson) {
        // 成功回调
        // 仅当ret为SUCCESS或未提供failure回调时调用
        // resJson.retType为数字，可以通过lib.mtop.RESPONSE_TYPE枚举来获得具体信息
        if(resJson.data.data) {
          var data = resJson.data.data;
          var faqs = data.faqs;
          me.$broadcast('update-logistics', data);
          if(faqs && faqs.length>0){
            me.$broadcast('recommend-question', faqs);
          }
        }
      }, function (resJson) {
        // 失败回调
        // resJson.retType为数字，可以通过lib.mtop.RESPONSE_TYPE枚举来获得具体信息
      });
    },
    'init-check': function(isCheck, entryType){
      this.$broadcast('is-check', isCheck, entryType, this.companyCode, this.mailNo);
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
  @import "assets/base.less";

  blockquote, body, button, dd, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, hr, input, legend, li, ol, p, pre, td, textarea, th, ul{
    margin:0;
    padding:0;
  }
  a {
    color: @link;
    text-decoration: none;
  }

  i, span {
    font-style: normal;
  }

  body {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    background-color: #fff;
    color: #222;
  }

  html, body {
    height: 100%;
    min-width: 1200px;
    overflow-y: hidden !important;
  }

  @font-face {
    font-family: 'iconfont';
    src: url('//at.alicdn.com/t/font_1476090492_7964656.eot'); /* IE9*/
    src: url('//at.alicdn.com/t/font_1476090492_7964656.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('//at.alicdn.com/t/font_1476090492_7964656.woff') format('woff'), /* chrome、firefox */
    url('//at.alicdn.com/t/font_1476090492_7964656.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
    url('//at.alicdn.com/t/font_1476090492_7964656.svg#rookie') format('svg'); /* iOS 4.1- */
  }

  .icon{
    font-family: 'iconfont';
  }

  .container {
    height: 100%;
    position: relative;
    top: -70px;
    overflow: hidden;
    width: 100%;

    //聊天部分 -- 左侧栏
    .main {
      width: 100%;
      margin-top: 70px;
      float: left;
    }
  }

  .pull-right {
    float: right;
  }
  .pull-left {
    float: right;
  }

  .clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
  }
  .clearfix {
    zoom: 1;
  }

  .shadow {
    color: @lightGray;
  }

  //公用客服气泡样式
  .message-template {
    margin: 10px;
    display: block;

    .person-icon {
      float: left;
      width: 48px;
      height: 48px;
      background-repeat: no-repeat;
      background-image: url("https://img.alicdn.com/tps/TB1I1XaNXXXXXcPXVXXXXXXXXXX-48-48.png");
      background-image: -webkit-image-set(url(https://img.alicdn.com/tps/TB1I1XaNXXXXXcPXVXXXXXXXXXX-48-48.png) 1x, url(https://img.alicdn.com/tps/TB1x6JBNXXXXXXAXXXXXXXXXXXX-96-96.png) 2x);
    }

    .message-container {
      float: left;
      min-height: 15px;
      min-width: 15px;
      max-width: 680px;
      margin-left: 15px;
      margin-top: 6px;
      border-radius: 4px;
      background: #fff;
      margin-right: 60px;
      padding: 10px;

      .triangle {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-right: 6px solid #fff;
        border-bottom: 6px solid transparent;
        margin-left: -16px;
      }

      .message {
        margin-top: -12px;
        font-size: 12px;
        img {
          max-width: 680px;
        }

        .message-header {
          height: 28px;
          color: @gray;
        }

        .split-line {
          height: 1px;
          border-top: 1px solid @border;
        }

        .message-body {
          padding: 10px 0;
          > ul {
            list-style: none;
            line-height: 26px;
          }

          .question-list {
            list-style: none;

            .questions {
              height: 48px;
              line-height: 48px;
              width: 110px;
              margin-left: 30px;

               >i {
                 margin-left: 20px;
               }
            }

            .question-icon {
              float: left;
              width: 48px;
              height: 48px;
              padding: 0 5px;
            }

            .search-icon {
              float: left;
              width: 48px;
              height: 48px;
              background-repeat: no-repeat;
              background-image: url("assets/search48.png");
              background-image: -webkit-image-set(url(assets/search48.png) 1x, url(assets/search96.png) 2x);
            }

            .send-icon {
              float: left;
              width: 48px;
              height: 48px;
              background-repeat: no-repeat;
              background-image: url("assets/send48.png");
              background-image: -webkit-image-set(url(assets/send48.png) 1x, url(assets/send96.png) 2x);
            }

            .receive-icon {
              float: left;
              width: 48px;
              height: 48px;
              background-repeat: no-repeat;
              background-image: url("assets/receive48.png");
              background-image: -webkit-image-set(url(assets/receive48.png) 1x, url(assets/receive96.png) 2x);
            }

            > li {
              float: left;
              text-align: left;
              border-right: 1px dotted @border;

              &:last-child {
                border-right: 0;
              }
              > ul {
                list-style: none;
                padding: 10px;
              }
            }
          }
        }

        .message-footer {
          padding-right: 20px;
          padding-top: 12px;
          /*height: 30px;*/

          .reliable-info {
            color: @gray;
            /*font-size: 12px;*/
          }
          a {
            float: right;
            color: @gray;
            font-size: 12px;
            margin: 0 20px;

            .reliable-text, .unreliable-text {
              position: absolute;
              margin-left: 4px;
              line-height: 24px;
            }
            .reliable-text {
              color: @textRed;
            }
            .unreliable-text {
              color: @textBlue;
            }

            .receive-icon, .unreliable-icon {
              font-size: 14px;
            }
            .reliable-icon {
              color: @textRed;
            }
            .unreliable-icon {
              color: @textBlue;
            }

            .lightRed, .lightBlue {
              width: 24px;
              height: 24px;
              display: inline-block;
              border-radius: 12px;
            }
            .lightRed {
              background-color: @lightRed;
            }
            .lightBlue {
              background-color: @lightBlue;
            }
            .lightRed.clicked {
              background-color: #fff;
            }
            .lightBlue.clicked {
              background-color: #fff;
            }

            .reliable-icon:before, .unreliable-icon:before {
              font-size: 16px;
              padding: 4px;
              width: 16px;
              height: 16px;
              line-height: 24px;
            }
            .reliable-icon:before {
              content: '\e628';
            }
            .unreliable-icon:before {
              content: '\e627';
            }
          }

          .unreliable, .reliable {
            width: 30px;
          }
          a.active .lightBlue, a.active .lightRed, a.disabled .lightBlue, a.disabled .lightRed{
            background-color: transparent;
          }

          a.disabled .icon, a.disabled .reliable-text, a.disabled .unreliable-text {
            color: @lightGray;
            cursor: default;
          }
        }

        .message-info {
          color: @gray;
        }
      }
    }
  }

  .user-message-template {
    float: right;
    max-width: 80%;
    .user-icon {
      float: right;
      width: 48px;
      height: 48px;
      background-repeat: no-repeat;
      background-image: url("https://img.alicdn.com/tps/TB1o7VVNXXXXXaBXXXXXXXXXXXX-48-48.png");
      background-image: -webkit-image-set(url(https://img.alicdn.com/tps/TB1o7VVNXXXXXaBXXXXXXXXXXXX-48-48.png) 1x, url(https://img.alicdn.com/tps/TB1TY0mNXXXXXbCaXXXXXXXXXXX-96-96.png) 2x);
    }
    .user-message-container {
      float: right;
      max-width: 80%;
      margin-right: 20px;
      margin-top: 6px;
      word-wrap: break-word;
      word-break: normal;

      .antiTriangle {
        float: right;
        margin-right: -6px;
        margin-top: 12px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-left: 6px solid @newBlue;
        border-bottom: 6px solid transparent;
      }

      .user-message {
        padding: 10px;
        background-color: @newBlue;
        border-radius: 4px;
        font-size: 12px;
        min-height: 14px;
        color: #fff;

        img {
          max-width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?ae88891e